import { useState, useEffect } from "react";
import {
  InputLabel,
  FormGroup,
  Paper,
  TextField,
  Typography,
  FormControl,
  Button,
  MenuItem,
  Select,
  FormHelperText,
} from "@material-ui/core";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { fetchTripbyId, updateTripdata} from "../api/customerapi";
import { makeStyles } from "@material-ui/core/styles";
import invoiceheader from "../invoice_header.png";
import account from "../account_details.png";
import footer from "../invoice_footer.png";
import {destAirport, identifydest, total, getconvdate, waiveofftotal} from "./date.js"

const useStyles = makeStyles((theme) => ({
  paper: {
    marginLeft: theme.spacing(10),
    marginRight: theme.spacing(10),
    justifyContent: "center",
    backgroundColor: "#f8f8f8",
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(4),
    width: theme.spacing(60),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  headertext: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  formgroup: {
    align: "center",
  },
  table: {
    marginLeft: theme.spacing(7),
  },
  textArea: {
    marginLeft: theme.spacing(12),
    marginRight: theme.spacing(14),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  button: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(4),
    width: theme.spacing(15),
    height: theme.spacing(6),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  button2: {
    marginLeft: theme.spacing(5),
    marginRight: theme.spacing(10),
    width: theme.spacing(20),
    height: theme.spacing(6),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  texttypo2: {
    color: "#a8020b",
    verticalAlign: "middle",
    marginLeft: theme.spacing(7),
    marginTop: 0,
    marginBottom: 0,
    fontStyle: "italic",
  },
  texttypo3: {
    marginTop: 0,
    marginBottom: 0,
    verticalAlign: "middle",
    marginLeft: theme.spacing(7),
   
  },

}));

const Invoice = () => {
  const classes = useStyles();
  const currenturl = window.location.href;
  const urlarray = currenturl.split("/");
  const currentid = urlarray[urlarray.length - 2];
  //console.log(currentid)
  // const total = () => {
  //   let sum = 0;
  //   if (cpdata.length == 0) {
  //     return sum;
  //   } else {
  //     cpdata.map((item) =>
  //       item.amount
  //         ? !(item.status == "Refund" || item.status=="Credit Note")
  //           ? (sum = sum + parseInt(item.amount))
  //           : (sum = sum - parseInt(item.amount))
  //         : sum
  //     );
  //     return sum;
  //   }
  // };
  const [cpdata, setcpdata] = useState([]);
  const [tripData, settripData] = useState({cust_payments:[]});
  const [stateData, setstateData] = useState({
    state: "",
    taxes: 0,
    details: "",
  });

  
  const getTrips = async (id) => {
    //console.log(id)
    try{
    const data = await fetchTripbyId(id);
    settripData(data.data)
    //console.log(data.data);
    setcpdata(data.data.cust_payments ? data.data.cust_payments : []);
  }catch(err){
    console.log(err)
  }
    
  };

  
  const gettcs2=()=>{
    var t=identifydest(tripData.primary_destination)
    //var landpart=total()-(tripData.visa_cp?tripData.visa_cp:0)-(tripData.cruise_cp?tripData.cruise_cp:0)-(tripData.anc_cp?tripData.anc_cp:0)-(tripData.flight_cp?tripData.flight_cp:0)-gettcs()
    var convdate=""
    var landpart=(total(tripData.cust_payments)-(tripData.visa_cp?tripData.visa_cp:0)-(tripData.anc_cp?tripData.anc_cp:0)-(tripData.extra_cp?tripData.extra_cp:0)-(tripData.flight_cp?tripData.flight_cp:0))/1.05
    if(t && !tripData.notax && !tripData.onlyflight && !tripData.fdom){
      if(tripData.trip_status=="Converted"){
        convdate="status_history" in tripData && tripData.status_history.length>0?tripData.status_history[tripData.status_history.length-1].date:""
    }else if(tripData.trip_status=="Closed"){
      convdate="status_history" in tripData && tripData.status_history.length>0?tripData.status_history[tripData.status_history.length-2].date:""
    }
     if(new Date(tripData.trip_start_date).getTime()>=new Date("2026-03-25").getTime()){
     landpart=(total(tripData.cust_payments)-(tripData.visa_cp?tripData.visa_cp:0)-(tripData.anc_cp?tripData.anc_cp:0)-(tripData.extra_sp?tripData.extra_sp:0)-(tripData.flight_cp?tripData.flight_cp:0))/1.02
      if(tripData.five_tcs){
            return landpart?Math.round((parseInt(landpart))*0.05):0
           }else{
            return landpart?Math.round((parseInt(landpart))*0.02):0
           }
      
  }else
    if(new Date(convdate).getTime()<new Date("2023-04-01").getTime()){
      return 0
    }else if(new Date(convdate).getTime()>new Date("2023-08-15").getTime()){
      landpart=(total(tripData.cust_payments)-(tripData.visa_cp?tripData.visa_cp:0)-(tripData.anc_cp?tripData.anc_cp:0)-(tripData.extra_cp?tripData.extra_cp:0)-(tripData.flight_cp?tripData.flight_cp:0))/1.05//console.log(tripData.if

      if(tripData.hightcs){
        return landpart?Math.round((parseInt(landpart))*0.2):0
      }else{
        return landpart?Math.round((parseInt(landpart))*0.05):0
      }
    
    }else{
      if(tripData.hightcs){
        return landpart?Math.round((parseInt(landpart))*0.2):0
      }else{
        return landpart?Math.round((parseInt(landpart))*0.05):0
      }
    }
       
        //return tripData.land_sp?Math.round((tripData.land_sp)*0.05):0
       
    }else{
        //console.log("DEF")
        //setprice({...price,tcs:0})
        return 0
    }
  }

  useEffect(() => {
    //console.log("useeffect called")
    getTrips(currentid);
    // gettaxes()
  }, [currentid]);

  //console.log(sum);

  const savepdf = async() => {
    let pdf = new jsPDF();
    const header = document.getElementById("imgheader");
    html2canvas(header).then((canvas) => {
      const imgHeader = canvas.toDataURL("image/jpeg", 0.5);
      const footer = document.getElementById("imgfooter");
      html2canvas(footer).then((canvas) => {
        const imgFooter = canvas.toDataURL("image/jpeg", 0.5);
        const initial = document.getElementById("maindata");
        html2canvas(initial).then((canvas) => {
          const initialdata = canvas.toDataURL("image/jpeg", 0.5);
          pdf.addImage(imgHeader, "JPEG", 0, 0);
          pdf.addImage(initialdata, "JPEG", 14, 60);
          pdf.addImage(imgFooter, "JPEG", 0, 165);
          pdf.save(
            tripData.cust_name + "_" + tripData.primary_destination + "_invoice"
          );
        });
      });
    });
    var printedTotal=total(tripData.cust_payments)+waiveofftotal(tripData.cust_payments)
    const finaltripData={...tripData, invoice_total:printedTotal}
    const updatetripResponse = await updateTripdata(
            tripData._id,
            finaltripData
          );
         
          if (
            updatetripResponse.status == 200 ||
            201 ||
            202 ||
            203 ||
            204 ||
            205 ||
            206 ||
            207
          ) {
            alert(
              "Payment data updated for trip with trip id " +
                updatetripResponse.data.trip_id
            );
            window.location =
              "/tripdataentry/" +
              updatetripResponse.data.trip_id +
              "/paymentupdate";
          } else {
            alert("Something went wrong. Contact support");
            window.location = "/";
          }
  };

  const gettcs=()=>{
    var t=identifydest(tripData.primary_destination)
     if(tripData.primary_destination=="Maldives" && new Date(getconvdate(tripData)).getTime()>new Date("2025-10-01").getTime()){
         t=0
       }
    var convdate=""
    var landpart=total(tripData.cust_payments)-(tripData.visa_cp?tripData.visa_cp:0)-(tripData.anc_cp?tripData.anc_cp:0)-(tripData.extra_cp?tripData.extra_cp:0)-(tripData.flight_cp?tripData.flight_cp:0)
    if(t && !tripData.no_tax && !tripData.only_flight && !tripData.no_tcs){
      if(tripData.trip_status=="Converted"){
        convdate="status_history" in tripData && tripData.status_history.length>0?tripData.status_history[tripData.status_history.length-1].date:""
    }else if(tripData.trip_status=="Closed"){
      convdate="status_history" in tripData && tripData.status_history.length>0?tripData.status_history[tripData.status_history.length-2].date:""
    }
   if(new Date(tripData.trip_start_date).getTime()>=new Date("2026-03-25").getTime()){
     landpart=(total(tripData.cust_payments)-(tripData.visa_cp?tripData.visa_cp:0)-(tripData.anc_cp?tripData.anc_cp:0)-(tripData.extra_sp?tripData.extra_sp:0)-(tripData.flight_cp?tripData.flight_cp:0))/1.02
     if(tripData.five_tcs){
            return landpart?Math.round((parseInt(landpart))*0.05):0
           }else{
            return landpart?Math.round((parseInt(landpart))*0.02):0
           }
     
      
  }else if(new Date(convdate).getTime()<new Date("2023-04-01").getTime()){
      return 0
    }else if(new Date(convdate).getTime()>new Date("2023-08-15").getTime()){

      if(tripData.hightcs){
        return tripData.land_sp || tripData.cruise_sp?Math.round((parseInt(tripData.land_sp)+parseInt(tripData.cruise_sp))*0.2):0
      }else{
        return tripData.land_sp || tripData.cruise_sp?Math.round((parseInt(tripData.land_sp)+parseInt(tripData.cruise_sp))*0.05):0
      }
      //console.log(tripData.cruise_sp)
     
    }else{
      if(tripData.hightcs){
        return tripData.land_sp?Math.round((tripData.land_sp)*0.2):0
      }else{
        return tripData.land_sp?Math.round((tripData.land_sp)*0.05):0
      }
      
    }
       
        //setprice({...price,tcs:price.landprice*0.05})
        
       
    }else{
        //console.log("DEF")
        //setprice({...price,tcs:0})
        return 0
    }
  }

  var sum = total(tripData.cust_payments) - stateData.taxes-gettcs(tripData);
  const landtax=total(tripData.cust_payments)-parseInt(tripData.flight_cp?tripData.flight_cp:0)-parseInt(tripData.visa_cp?tripData.visa_cp:0)-parseInt(tripData.anc_cp?tripData.anc_cp:0)-parseInt(tripData.extra_cp?tripData.extra_cp:0)-parseInt(tripData.cruise_cp?tripData.cruise_cp:0)-gettcs2(tripData)
  const inittaxes=(landtax-landtax/1.05).toFixed(2)
//  console.log(inittaxes);
//   console.log(sum);
  return (
    <div>
      <Button
        variant="contained"
        color="primary"
        className={classes.button}
        onClick={savepdf}
      >
        PDF
      </Button>
      <Button
        href={"/tripdataentry/" + tripData.trip_id + "/paymentupdate"}
        variant="contained"
        color="secondary"
        className={classes.button}
      >
        Back
      </Button>
      
      <TextField
        variant="outlined"
        disabled
        InputLabelProps={{ shrink: true }}
        label="State"
        value={tripData.cust_state }
        className={classes.textField}
        
      />
      <TextField
        variant="outlined"
        
        InputLabelProps={{ shrink: true }}
        label={"Taxes (number) Calc="+inittaxes}
        value={stateData.taxes}
        className={classes.textArea}
        onChange={(e) => {
          setstateData({ ...stateData, taxes: e.target.value });
        }}
      />
      <br></br>
      <FormGroup row className={classes.formgroup}>
        <TextField
          variant="outlined"
          label="Details"
          value={stateData.details}
          className={classes.textArea}
          fullWidth
          multiline
          onChange={(e) =>
            setstateData({ ...stateData, details: e.target.value })
          }
        />
      </FormGroup>
      <br></br>
      <div id="imgheader" className={classes.formgroup}>
        <img src={invoiceheader} width="795" alt="quote header"></img>
      </div>
      <div id="maindata" className={classes.table}>
        {tripData.cust_state == "New Delhi" ? (
          <div>
            <table border="1" width="700">
              <tr>
                <td><b>Name:</b>{tripData.cust_name}</td>
                <td><b>State:</b>{tripData.cust_state}</td>
              </tr>
              <tr>
                <td colspan="2">{stateData.details}</td>
              </tr>
              <tr>
                <td>Tour Package for {tripData.primary_destination}</td>
                <td>{sum+waiveofftotal(tripData.cust_payments)}</td>
              </tr>
              <tr>
                <td>Taxes (CGST+SGST):</td>
                <td>
                  {stateData.taxes / 2}+{stateData.taxes / 2}
                </td>
              </tr>
              {identifydest(tripData.primary_destination) && gettcs(tripData)?(
                <tr>
              
              <td>TCS:</td>
              <td>
                {gettcs(tripData)}
              </td>
            </tr>
              ):("")}
              
              <tr>
                <td>Total:</td>
                <td>{total(tripData.cust_payments)+waiveofftotal(tripData.cust_payments)}</td>
              </tr>
            </table>
          </div>
        ) : (
          <div>
            <table border="1" width="700">
              <tr>
                <td>Name:{tripData.cust_name}</td>
                <td>State:{tripData.cust_state}</td>
              </tr>
              <tr>
                <td colspan="2">{stateData.details}</td>
              </tr>
              <tr>
                <td>Tour Package for {tripData.primary_destination}</td>
                <td>{sum+waiveofftotal(tripData.cust_payments)}</td>
              </tr>
              <tr>
                <td>Taxes (IGST):</td>
                <td>{stateData.taxes}</td>
              </tr>
              {identifydest(tripData.primary_destination) && gettcs(tripData)?(
                <tr>
              
              <td>TCS:</td>
              <td>
                {gettcs(tripData)}
              </td>
            </tr>
              ):("")}
              <tr>
                <td>Total:</td>
                <td>{total(tripData.cust_payments)+waiveofftotal(tripData.cust_payments)}</td>
              </tr>
            </table>
          </div>
        )}
        <br></br>

        <table border="1" width="700">
          <tr>
            <th className={classes.daypara} align="left" width="230">
              <b>Date </b>
            </th>
            <th className={classes.daypara} align="left" width="230">
              <b>Amount </b>
            </th>
            <th className={classes.daypara} align="left" width="230">
              <b>Status </b>
            </th>
          </tr>
        </table>

        {cpdata.map((cp) => {
          return (
            <div id={cp.id}>
              <table border="1" width="700">
                <tr>
                  <td className={classes.daypara} align="left" width="230">
                    <div class="col" className={classes.column2}>
                      {cp?.date.split("T").slice(0, 1)}
                    </div>
                  </td>
                  <td className={classes.daypara} align="left" width="230">
                    <div class="col" className={classes.column2}>
                      {cp?.amount}
                    </div>
                  </td>
                  <td className={classes.daypara} align="left" width="230">
                    <div class="col" className={classes.column2}>
                      {cp?.status}
                    </div>
                  </td>
                </tr>
              </table>
            </div>
          );
        })}
      </div>

      <div id="imgfooter" className={classes.formgroup}>
        
        <h4 className={classes.texttypo2}>Payment Methods:</h4>
        <h6 className={classes.texttypo2}>UPI</h6>
        <h6 className={classes.texttypo3}>UPI id: jetovacations@kotak</h6>
        <br></br>
        <h6 className={classes.texttypo2}>Bank transfer</h6>
        <h6 className={classes.texttypo3}>Beneficiary: Jeto Vacations Private Limited</h6>
        <h6 className={classes.texttypo3}>Bank: Kotak Mahindra Bank</h6>
        <h6 className={classes.texttypo3}>Account Number: 8912958952</h6>
        <h6 className={classes.texttypo3}>IFSC: KKBK0004629</h6>
        <br></br>
        <Typography className={classes.texttypo2}>Additional charges between 2.36%-3.54% for payment using payment gateway and for UPI transactions with Rupay Credit cards</Typography>
        <Typography className={classes.texttypo2}>Cancellation charged by Jeto Vacations are Rs. 2,999 per person + applicable </Typography>
        <Typography className={classes.texttypo2}>cancellation charges of hotel/airlines/activity operators/transporters </Typography>
        <br></br>
        <Typography className={classes.texttypo2}>By making payment, you agree to abide the terms and conditions mentioned at https://www.jetovacations.com/tnc </Typography>
        <br></br>
        <Typography className={classes.texttypo2}>Refer a friend and share rewards up to Rs. 5000. <a href="https://www.jetovacations.com/quoterequest7?utm_source=doc&utm_medium=doc&utm_campaign=lead">Refer Now</a></Typography>
        
        <br></br>
        <img src={footer} width="795" alt="quote footer"></img>
      </div>
    </div>
  );
};

export default Invoice;
